import { css } from "@emotion/css";
import {
  Box,
  Paper,
  Popover,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { bindPopover } from "material-ui-popup-state";
import { bindTrigger, usePopupState } from "material-ui-popup-state/hooks";
import React, { useContext, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as MoreIcon } from "../../assets/images/ralvie/more-icon.svg";
import { ReactComponent as SundialLogoDark } from "../../assets/images/ralvie/sundial-logo-small-dark.svg";
import { ReactComponent as SundialLogo } from "../../assets/images/ralvie/sundial-logo-small.svg";
import CustomTypography from "../../components/CustomTypography";
import CommonUtil from "../../util/CommonUtils";
import ActivityEventDetails from "./ActivityEventDetails";
import { TimesheetContext } from "../../util/context";

export default function ActivityItem(props) {
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const { t } = useTranslation();
  const duration = CommonUtil.getDurationWithoutRoundoff(props.duration);
  const popupMore = usePopupState({
    variant: "popover",
    popupId: "demo-popup-popover",
  });
  const { subEventSelected = [] } = useContext(TimesheetContext);

  const scrollRef = useRef(null);
  const handleMouseOver = (event) => {
    // const element = event.target;
    // const rect = element.getBoundingClientRect();
    // let position = isXlScreen ? 900 : 650;
    // if (scrollRef.current) {
    //   scrollRef.current.scrollIntoView({
    //     behavior: "smooth",
    //     inline: rect.left > position || rect.left < 200 ? "center" : "nearest",
    //     block: "nearest",
    //   });
    // }
    props.setShowMore("inline");
  };
  useEffect(() => {
    if (popupMore.isOpen) {
      props.setShowMore("inline");
    }
  }, [popupMore]);

  return (
    <Box display="flex" columnGap={0.5} width={"auto"}>
      <div
        onMouseOut={() => {
          props.setShowMore("none");
        }}
        onMouseOver={handleMouseOver}
        ref={scrollRef}
        style={{
          height: "100%",
          overflow: "hidden",
          background: "var(--background-color-3)",
          minWidth: "100%",
        }}
        className={`selectedCardLeftBorder ${css`
          border-left: 4px solid
            ${props?.isLogged || subEventSelected?.includes(props.event.eventId)
              ? "#4F4F4F"
              : props?.loggedEvents > 0
              ? "#707070"
              : props?.isSelected
              ? "#4F4F4F"
              : props.event.dark} !important;
        `}`}
      >
        <div
          id="activity-calendar"
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            columnGap: "8px",
            background:
              props.isLogged || subEventSelected?.includes(props.event.eventId)
                ? "#919191"
                : props.loggedEvents > 0
                ? props.mode === "dark"
                  ? "#010101"
                  : "#D9D9D9"
                : props.isSelected
                ? "#919191"
                : props.event.light,
            padding: " 4px 8px",
            height: "100%",
          }}
          onMouseOver={() => {
            if (props.isLogged) {
              document.getElementById("event-text").style.color = "#010101";
            }
          }}
          onMouseOut={() => {
            if (props.isLogged) {
              document.getElementById("event-text").style.color = "";
            }
          }}
        >
          <Box
            display="flex"
            flexGrow={1}
            columnGap={1}
            onClick={() => props.logEvent(props.event)}
          >
            <div>
              {props.event?.application?.icon ? (
                <img
                  src={props.event?.application?.icon}
                  alt=""
                  height={14}
                  width={14}
                />
              ) : (
                props.getApplicationIcon(props.event)
              )}
            </div>
            <div
              // style={{ minWidth: isXlScreen ? "76%" : "70%" }}
              style={{ flexGrow: "1" }}
              onClick={() => props.logEvent(props.event)}
            >
              <div style={{ paddingTop: "2px" }}>
                <CustomTypography
                  text={props.description}
                  sx={{
                    font:
                      CommonUtil.getOS() === "MacOS"
                        ? "normal normal normal 14px/24px GothamMedium"
                        : "normal normal normal 14px/16px GothamMedium",
                    textTransform: "capitalize",
                    textWrap: "wrap",
                    color: props.isLogged
                      ? "#474B4F"
                      : props.loggedEvents > 0
                      ? props.mode === "dark"
                        ? "#f8f8f8cc"
                        : "#474B4F"
                      : "",
                  }}
                >
                  {props?.event?.application?.name}
                </CustomTypography>
              </div>

              {props.showDetails && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: "8px",
                    rowGap: "8px",
                    width: "100%",
                  }}
                >
                  <Typography
                    variant="activity_duration"
                    style={{
                      fontSize: "0.7rem",
                      color: props.isLogged
                        ? "#474B4F"
                        : props.loggedEvents > 0
                        ? props.mode === "dark"
                          ? "#f8f8f880"
                          : "#474B4F"
                        : "",
                    }}
                  >
                    {duration.hr +
                      "h " +
                      duration.min +
                      "m " +
                      duration.sec +
                      "s"}
                  </Typography>

                  <Box display="flex" alignItems="center" height="20px">
                    <Box item>
                      {props.isLogged ? (
                        <SundialLogo height={"10px"} />
                      ) : props.mode === "light" ? (
                        <SundialLogo height={"10px"} />
                      ) : (
                        <SundialLogoDark height={"10px"} />
                      )}
                    </Box>
                    <Box display="flex" alignItems="center" pl={1}>
                      <Typography
                        variant="activity_log_count"
                        style={{
                          fontSize: "0.6rem",
                          color: props.isLogged
                            ? "#474B4F"
                            : props.mode === "dark"
                            ? "#f8f8f880"
                            : "#242424cc",
                        }}
                      >
                        {props.loggedEvents + "/" + props.event?.events?.length}
                      </Typography>
                    </Box>
                  </Box>
                </div>
              )}
            </div>
          </Box>

          <div>
            <Box display={"flex"}>
              <Box
                item
                px={1}
                pt={0.5}
                sx={{
                  width: "10%",
                  flexWrap: "nowrap",
                  zIndex: 1000,
                  "& .more_svg": {
                    transition: "color 0.3s ease",
                    color:
                      props.mode === "dark"
                        ? "var(--color-33-50)"
                        : "#242424cc",
                  },
                  "&:hover": {
                    "& .hover-text, & .more_svg": {
                      color: props.mode === "dark" ? "#f8f8f8cc" : "#242424",
                    },
                  },
                }}
                display={props.showMore}
                {...bindTrigger(popupMore)}
              >
                <MoreIcon className="icon more_svg" />
              </Box>
            </Box>
          </div>
        </div>
      </div>
      {props?.showMore === "inline" && !popupMore.isOpen && (
        <Box
          onMouseOut={() => {
            props.setShowMore("none");
          }}
          onMouseOver={() => {
            if (!props?.isSelecting) {
              props.setShowMore("inline");
            }
          }}
          component={Paper}
          // className={`selectedCardLeftBorder ${css`
          //   border-left: 4px solid
          //     ${props?.isLogged
          //       ? "#EA4335"
          //       : props?.loggedEvents > 0
          //       ? "#919191"
          //       : props?.isSelected
          //       ? "#919191"
          //       : props.event.dark} !important;
          // `}`}
          sx={{
            background: "var(--background-color-3)",
            minWidth: "125%",
            borderRadius: "2px",
          }}
        >
          <ActivityEventDetails
            event={props.event}
            isLogged={props.isLogged}
            loggedEvents={props.loggedEvents}
          />
        </Box>
      )}
      <Popover
        {...bindPopover(popupMore)}
        disableAutoFocus={false}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          onClick={() =>
            props.handleHideEvents(props.hiddenEvents > 0 ? false : true)
          }
          py={1}
          px={2}
          className={css`
            background: ${props.mode === "dark" ? "#101010" : "#ffffff"} 0% 0%
              no-repeat padding-box;
            color: ${props.mode === "dark" ? "#f8f8f8cc" : "#242424"};
            box-shadow: 0px 3px 6px #00000026;
            opacity: 1;
            cursor: pointer;
          `}
        >
          {props.hiddenEvents > 0 ? t("RAL0564") : t("RAL0563")}
        </Box>
      </Popover>
    </Box>
  );
}
